import MockAdapter from 'axios-mock-adapter';

export default MockAdapter;